import { z } from 'zod';

export interface PersonValidationMessages {
    first_name_required?: string;
    first_name_max?: string;
    last_name_required?: string;
    last_name_max?: string;
    email_required?: string;
    email_invalid?: string;
    email_max?: string;
    position_max?: string;
    company_required?: string;
}

const defaultMessages: Required<PersonValidationMessages> = {
    first_name_required: 'First name is required',
    first_name_max: 'First name must be less than 255 characters',
    last_name_required: 'Last name is required',
    last_name_max: 'Last name must be less than 255 characters',
    email_required: 'Email is required',
    email_invalid: 'Please enter a valid email address',
    email_max: 'Email must be less than 255 characters',
    position_max: 'Position must be less than 255 characters',
    company_required: 'Company is required',
};

function buildSchema(messages: Required<PersonValidationMessages>, options: { requireCompany: boolean }) {
    const companySchema = options.requireCompany
        ? z.string({ error: messages.company_required }).min(1, messages.company_required)
        : z.string().nullable().optional();

    return z.object({
        first_name: z.string().min(1, messages.first_name_required).max(255, messages.first_name_max),
        last_name: z.string().min(1, messages.last_name_required).max(255, messages.last_name_max),
        email: z.string().min(1, messages.email_required).email(messages.email_invalid).max(255, messages.email_max),
        phone: z.string().optional(),
        position: z.string().max(255, messages.position_max).optional(),
        accounting: z.boolean().optional(),
        company_id: companySchema,
    });
}

export function createPersonValidationSchema(
    options: {
        messages?: PersonValidationMessages;
        requireCompany?: boolean;
    } = {},
) {
    const messages = { ...defaultMessages, ...(options.messages ?? {}) };
    return buildSchema(messages, { requireCompany: options.requireCompany ?? true });
}

export const personValidationSchema = buildSchema(defaultMessages, { requireCompany: false });

export type PersonValidation = z.infer<typeof personValidationSchema>;
